import { getCategoryColor } from '@/utils/category/getCategoryColor'
import { getCategoryIcon } from '@/utils/category/getCategoryIcon'
import { cn } from '@/utils/cn'
import { Tooltip, TooltipContent, type TooltipProps } from './tooltip'

interface CategoryTooltipProps {
  category: string
}

type Props = CategoryTooltipProps & Pick<TooltipProps, 'className' | 'tabIndex'>

export const CategoryTooltip = ({ category, className, tabIndex }: Props) => {
  const Icon = getCategoryIcon(category)
  const color = getCategoryColor(category)

  return (
    <Tooltip
      tabIndex={tabIndex}
      className={cn(
        'relative z-[1] flex min-h-6 min-w-6 items-center justify-center rounded-full border border-transparent bg-transparent',
        'hocus:border-border hocus:bg-surface',
        className
      )}
    >
      <Icon size={16} style={{ color: `rgb(var(${color}))` }} />
      <TooltipContent side="top">
        <div className="flex items-center gap-2">
          <Icon size={16} style={{ color: `rgb(var(${color}))` }} />
          <span>{category}</span>
        </div>
      </TooltipContent>
    </Tooltip>
  )
}
